
import { getImg } from '@/pages/home/_config/getImgs';
import _default from '@/pages/home/assets/svg/dashboard/default.svg';
import { storage } from '@/utils/utils';
import { DB_DASHBOARD_LOCAL_CURRENT_GAME_KEY } from '@/pages/dashboard/_config/constant';
import { OFFICIAL_WEBSITE } from './constant';

export const getSystemFlag = (code: string, source?: object) => {
  // 从前端缓存获取当前游戏gameCode
  const { code: gameCode } = storage.getItem(DB_DASHBOARD_LOCAL_CURRENT_GAME_KEY) || {};
  let systemCode = code?.trim()?.toLowerCase();
  if (OFFICIAL_WEBSITE.includes(systemCode) && gameCode) {
    const combinedCode = `${gameCode?.toLowerCase()?.trim()}_${systemCode}`;
    systemCode = combinedCode;
  }
  if (systemCode === 'others' || code === '其他') return '';
  let img = '';
  try {
    if(systemCode?.startsWith('playstation') || systemCode?.startsWith('ps')){
      img = getImg('playstation', source) ?? _default;
    } else {
      img = getImg(systemCode, source) ?? _default;
    }
  } catch (e) {
    img = _default;
  }
  return img;
};